import React from 'react';

import {
  SidebarIconButton,
  ToggleButtonWrapper,
} from 'app/components/general/DetailPage/RightSidebar/structure/StickyButtons';
import {gt} from 'app/utils/i18n';

import type {StickyMenuType} from 'app/components/general/DetailPage/RightSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

export function StickyDocumentMenuButton<ItemType extends DetailPageItemType>({
  buttonDelta,
  setFullscreenState,
}: StickyMenuType<ItemType> & {
  setFullscreenState: () => void;
}) {
  return (
    <ToggleButtonWrapper buttonDelta={buttonDelta}>
      <SidebarIconButton
        tooltip={gt('Expand document view')}
        onClick={setFullscreenState}
        icon={'fa-align-left'}
      />
    </ToggleButtonWrapper>
  );
}
